export const references = [
    {
        text: "Department of Health (2015). Caring for the heart, prevention of cardiovascular diseases. Retrieved 7 May 2021, from",
        href: "https://www.studenthealth.gov.hk/tc_chi/newsletters/files/bridge66.pdf",
    },
    {
        text: "Department of Health (2019). Blood Lipid Disorders. Retrieved 7 May 2021, from ",
        href: "https://www.kidney.org/atoz/content/polycystic",
    },
    {
        text: "Oral cholesterol lowering drugs. (n.d.). Retrieved April 01, 2021, from ",
        href: "https://www.drugoffice.gov.hk/eps/do/tc/consumer/news_informations/dm_05.html",
    },
    {
        text: "Department of Health (2021). High cholesterol. Retrieved 7 May 2021, from ",
        href: "https://www.chp.gov.hk/files/her/exnnutp036_tc.pdf",
    }, {
        text: "Ostlund RE. Phytosterols, Cholesterol Absorption and Healthy Diets. Lipids 2007; 42(1): 41-5.",
    }, {
        text: "威爾斯親王醫院內科及藥物治療部(2005). 飲食與預防中風.  Retrieved 6 April 2021, from ",
        href: "https://www3.ha.org.hk/pwh/patient%20edu/stoke/CVA%20booklet/chapter%207%20chinese.pd",
    },
    {
        text: "The Centre for Health Protection (n.d).  中風. Retrieved 30 March 2021, from ",
        href: "https://www.chp.gov.hk/tc/static/90076.html",
    },
    {
        text: "World Health Organization. (2020). The top 10 causes of death. Retrieved March 30, 2021, from ",
        href: "https://www.who.int/news-room/fact-sheets/detail/the-top-10-causes-of-death",
    },
    {
        text: "Hospital Authority (2021). Stroke. Retrieved 30 March 2021, from ",
        href: "https://www21.ha.org.hk/smartpatient/SPW/zh-hk/Disease-Information/Disease/?guid=29ac1219-3d68-4378-a2bd-09e111da3650",
    },
    {
        text: "U.S. Department of Health and Human Services -Public Health Service -National Institutes of Health (2005).High Blood Cholesterol. Retrieved 28 Sep, 2021 from ",
        href: "https://www.nhlbi.nih.gov/files/docs/public/heart/wyntk.pdf",
    },
    {
        text: "Monda KL, Ballantyne CM, North KE. Longitudinal impact of physical activity on lipid profiles in middle-aged adults:the Atherosclerosis Risk in Communities Study. J Lipid Res 2009; 50(8):1685-91.",
    },
    {
        text: "Centre for Health Protection (2011). 智對膽固醇. Retrieved 7 May 2021, from ",
        href: "https://www.chp.gov.hk/files/pdf/ncd_watch_sep2011_chi.pdf",
    },
    {
        text: "Simonen P. P., Gylling H. K. , Miettinen T. A. (2002). Diabetes Contributes to Cholesterol Metabolism Regardless of Obesity. Diabetes Care. doi: 10.2337/diacare.25.9.1511",
    },
    {
        text: "van den Nieuwenhoff, H. W. P., Mesters, I., Gielen, C., & de Vries, N. K. (2007). Family communication regarding inherited high cholesterol: Why and how do patients disclose genetic risk? Social Science & Medicine, 65(5), 1025–1037.",
        href: "https://doi.org/10.1016/j.socscimed.2007.04.008",
    },
    {
        text: "Tonstad, S., & Després, J.-P. (2011). Treatment of lipid disorders in obesity. Expert Review of Cardiovascular Therapy, 9(8), 1069–1080. https://doi.org/10.1586/erc.11.83",
    },
    {
        text: "C. Abana, E. (2020). BMI Assessment Machine with Recommended Ideal Weight. International Journal of Advanced Trends in Computer Science and Engineering, 9(3), 4163–4167.",
        href: "https://doi.org/10.30534/ijatcse/2020/247932020",
    },
    {
        text: "Mach F, Baigent C, Catapano AL, et al. 2019 ESC/EAS Guidelines for the management of dyslipidaemias: lipid modification to reduce cardiovascular risk: The Task Force for the management of dyslipidaemias of the European Society of Cardiology (ESC) and European Atherosclerosis Society (EAS). Eur Heart J 2019; 41(1): 111-88.",
    },
    {
        text: "Chaudhary, R., Garg, J., Shah, N., & Sumner, A. (2017). Pcsk9 inhibitors: A new era of lipid lowering therapy. World Journal of Cardiology, 9(2), 76. doi:10.4330/wjc.v9.i2.76",
    },
    {
        text: "Cordero, A., Rodríguez-Mañero, M., Fácila, L., Fernández-Olmo, M. R., Gómez-Martínez, M. J., Valle, A., . . . González-Juanatey, J. R. (2020). Prevention of myocardial infarction and stroke with pcsk9 inhibitors treatment: A meta analysis of recent randomized clinical trials. Journal of Diabetes & Metabolic Disorders,19(2), 759-765. doi:10.1007/s40200-020-00557-6",
    },
];
